module.exports = __webpack_public_path__ + "static/media/5.4954c8d6.jpg";